import styled from 'styled-components';

export const WrapperGrid = styled.div`
  display: flex;
  padding: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  strong{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 24px;
    margin:20px;
  }
  .section-button{
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
  }
  '& div.select-container': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px', // Ajusta el margen inferior según tus necesidades
    // Otros estilos si es necesario
  }
`;
